import React, { useState } from 'react'
import { firestore } from '../../../firebase'
import TeamsSelector from '../Team/TeamsSelector'

function AddStatsPlayer({player}) {

    const [fixtures, setFixtures] = useState(0)
    const [goals, setGoals] = useState(0)
    const [assists, setAssists] = useState(0)
    const [season, setSeason] = useState(2020)
    const [teamId, setTeamId] = useState("")
    const [teamName, setTeamName] = useState("")

    const [error, setError] = useState("")

    async function addStatsHandler(e) {
        e.preventDefault();
        try {
            const playerStatsRef = firestore.collection("players-fb").doc(player.id).collection("player-stats")

            const data = {
                fixtures,
                goals,
                assists,
                season, 
                team_id: teamId,
                team_name: teamName
            }
            playerStatsRef.add(data)

        } catch (error) {
            setError(error.message)
        }

    }

    const seasons = [2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006]

    return (
        <form onSubmit={addStatsHandler}>

            <TeamsSelector teamId={teamId} setTeamId={setTeamId} teamName={teamName} setTeamName={setTeamName} />

            <label>Kamper</label>
            <input value={fixtures} onChange={e => setFixtures(e.target.value)} className="form-control mb-2" type="number" />

            <label>Mål</label>
            <input value={goals} onChange={e => setGoals(e.target.value)} className="form-control mb-2" type="number" />

            <label>Assists</label>
            <input value={assists} onChange={e => setAssists(e.target.value)} className="form-control mb-2" type="number" />

            <label>Velg sesong</label>
            <select className="browser-default custom-select" onChange={e => setSeason(e.target.value)}>
                <option>Velg sesong</option>
                {seasons.map((season, index) => {
                    return (
                        <option key={index} value={season}>{season}</option>
                    )
                })}
            </select>

            <label>Fyll ut sesong manuelt:</label>
            <input value={season} onChange={e => setSeason(e.target.value)} className="form-control mb-2" type="number" />

            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-primary btn-rounded">Legg til statistikk</button>
        </form>
    )
}
export default AddStatsPlayer